import React from "react";
import { FolderIcon } from "@common/folderIcon";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import { StatusList } from "./statusList";
import styles from "./styles.scss";
import { useProjectStatusesRetrieval } from "@planzone/view-models";

function ProjectStatus({ project, selectStatus }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    statuses,
    retrieveProjectStatuses,
  } = useProjectStatusesRetrieval();
  const openStatus = statuses.find((status) => status.label === "pz_open");

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectStatuses();
  }, []);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectStatuses();
  }, []);

  React.useEffect(() => {
    project.status &&
      project.status.uuid === "" &&
      openStatus &&
      selectStatus(openStatus);
  }, [
    project.status && project.status.uuid ? project.status.uuid : "",
    openStatus,
  ]);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.projectStatus}>
          <div
            className={styles.selectedStatus}
            style={{ borderColor: project.status.color || "#FEA439" }}
            onClick={isVisible ? hide : show}
          >
            <FolderIcon
              className={styles.folderIcon}
              style={{ fill: project.status.color || "#FEA439" }}
              isOpen={false}
            />
            <p className={styles.name}>
              {t(
                `projectStatuses.${project.status.label}`,
                project.status.label || "Ouvert",
              )}
            </p>
            <ToggleArrow
              className={styles.toggleArrow}
              style={{ fill: project.status.color || "#FEA439" }}
            />
          </div>
          {isVisible && (
            <div className={styles.menu}>
              <StatusList
                project={project}
                statuses={statuses}
                selectStatus={(status) => {
                  selectStatus(status);
                  hide();
                }}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ProjectStatus };
